import React, {
  useState,
  useRef,
  useEffect,
} from "react";
import {
  Box,
  Container,
  Stack,
  Typography,
} from "@mui/material";

import { set } from "lodash";

import {
  getOptions,
  putOptions,
  AccountUrl_get,
  AccountUrl_put,
  ftchPlus,
  CleanAvail,
} from "../../App/Account_urls.jsx";
import ValueInflatable from "../../App/ValueInflatable.jsx";
import { AddDialog } from "../../Components/AddDialog.jsx";
import { InputPercentage } from "../../Components/Inputs/Input_Percentage.jsx";
import { Input_label, InputName } from "../../Components/Inputs/Input_Name.jsx";
import { errorClear, errorJsonHasErrors, errorSetPlus } from "../../Components/Inputs/Input_Fns.jsx";
import { CollapseDelete } from "../../App/CollapseButtons.jsx";
import { InputYear } from "../../Components/Inputs/Input_Year.jsx";
import { InputSelect1ES } from "../../Components/Inputs/Select.jsx";
import { InputCheck } from "../../Components/Inputs/Input_Check.jsx";
import { InputNumber } from "../../Components/Inputs/Input_Number.jsx";
import { Arrayify } from "../../Functions/utils.jsx";


var defAnnuity = {
  Name: "",

  Annual: {
    AnnuityType: "Registered",
    GuaranteeYears: 0,
    PurchaseAccount: "",
    PurchasePercent: 0,
    PurchaseYear: new Date().getFullYear() - 1,
    Purchase: {
      Value: 0,
      Year: new Date().getFullYear() - 1,
      Threshold: 0,
      Type: "Yearly",
      Rate: 0,
    },
    PaymentYearStart: new Date().getFullYear() - 1,
    PaymentYearEnd: 0,
    PaymentPercent: 0,
    PaymentSurvivorPercent: 75,
    DeferredRate: 0,
    Payment: {
      Value: 0,
      Year: new Date().getFullYear() - 1,
      Threshold: 0,
      Type: "Yearly",
      Rate: 0,
    },
    PrimaryAnnuitant: "",
    JointAnnuitant: "",
    InterestRate: 0
  },

};

const Annual = ({ avail, form, onChange, onError }) => {
  const [errors, setErrors] = useState({})

  const onChange_any = (n, v) => {

    let nf = {
      ...form,
      [n]: v,
    };
    console.log(nf);
    onChange(nf);
    validate(nf)
    return nf
  };

  const onChangeInfValue = (form, upto, spousePercentage, name) => {
    onChange_any(name, form);
  };



  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);

  };


  const myError = (obj, i, err) => {
    errorSetPlus(onError, errors, setErrors, obj, i, err)
  }


  const validate = (nf) => {
    if (nf) {
      let ne = structuredClone(errors)


      let PurchasePercent = Number(nf.PurchasePercent)
      let cost = Number(nf.Purchase.Value)
      let PurchaseYear = Number(nf.PurchaseYear)
      if (PurchaseYear !== 0 || PurchasePercent !== 0 || cost !== 0 || nf.PurchaseAccount !== "") {
        ne = set(ne, "PurchaseYear", (PurchaseYear === 0) ? "Required" : "")
        ne = set(ne, "PurchaseAccount", (nf.PurchaseAccount === "") ? "Required" : "")
        ne = set(ne, "PurchasePercent", (PurchasePercent !== 0 && cost !== 0) ? "Only % or Value" : "")
        if (ne.PurchasePercent === "") {
          ne = set(ne, "PurchasePercent", (PurchasePercent === 0 && cost === 0) ? "Required % or Value" : "")
        }

      }




      let paymentPercent = Number(nf.PaymentPercent)
      let payment = Number(nf.Payment.Value)
      // let paymentStartYear = Number(nf.PaymentStartYear)
      // let paymentEndtYear = Number(nf.PaymentEndYear)
      // let PaymentSurvivorPercent = Number(nf.PaymentSurvivorPercent)

      ne.PaymentPercent = (paymentPercent !== 0 && payment !== 0) ? "Only % or Value" : ""
      console.log(ne.PaymentPercent)
      if (ne.PaymentPercent === "") {
        console.log("AAAAAA")
        ne.PaymentPercent = (paymentPercent === 0 && payment === 0) ? "Required % or Value" : ""
      }



      setErrors(ne)
      console.log(ne)
      if (onError !== null) {
        onError(errorJsonHasErrors(ne) ? "Errors" : "")
      }
    }
  }



  return (
    <Container maxWidth="true">
      <Box sx={{ my: 2, p: 2, border: "1px solid grey" }}>
        <Stack spacing={2} sx={{ my: 2 }}>
          <Stack direction="row" spacing={2}>
            <InputSelect1ES
              label="Type"
              value={form.AnnuityType}
              name="AnnuityType"
              onChange={onChange_t}
              avail={avail.AnnuityTypes}
              errors={errors}
              onError={(e) => myError("pannuitants", null, e)}
            />

          </Stack>
          <Typography id="s-die-age-slider" variant="h6" gutterBottom>
            Purchase
          </Typography>

          <Stack direction="row" spacing={2}>

            <InputYear
              name="PurchaseYear"
              year={form.PurchaseYear}
              birthYear={form.BirthYear}
              onChange={onChange_t}
              // some military pensions are 20 years after start
              required={false}
              tooltip="Year in which we will purchase the annuity "
              errors={errors}
              onError={(e) => myError("PurchaseYear", null, e)}

            />
            <InputSelect1ES
              label="Account"
              value={form.PurchaseAccount}
              name="PurchaseAccount"
              onChange={onChange_t}
              avail={form.AnnuityType === "Registered" ? avail.RegisteredAccounts : avail.PrescribedAccounts}
              errors={errors}
              onError={(e) => myError("pannuitants", null, e)}
            />


            <InputPercentage
              label="Account %"
              name="PurchasePercent"
              percent={form.PurchasePercent}
              onChange={onChange_t}
              // disabled={form.Purchase.Value > 0}

              width={90}
              tooltip="Percentage of the account to purchase this annuity"
              errors_={errors}
              onError={(e) => myError("inputpercent", null, e)}
            />
            <ValueInflatable
              form={form.Purchase}
              onChange={onChangeInfValue}
              avail={avail}
              tooltip="Value of the Account to purchase this annuity"
              name="Purchase"
              errors_={errors}
              onError={(e) => myError("valueI", null, e)}
            />


          </Stack>
          <Typography id="s-die-age-slider" variant="h6" gutterBottom>
            Defer
          </Typography>


          <Stack direction="row" spacing={2}>
            <InputYear
              label="Start Year"
              name="PaymentStartYear"
              year={form.PaymentStartYear}
              birthYear={form.BirthYear}
              minAge={form.PurchaseYear > 0 ? form.PurchaseYear - form.BirthYear : 18}
              maxAge={form.AnnuityType === "Prescribed" && form.PurchaseYear > 0 ? form.PurchaseYear + 1 - form.BirthYear : 100}
              onChange={onChange_t}
              required={true}
              width={110}
              tooltip="Year in which we will start receiving the annuity payment "
              errors_={errors}
              onError={(e) => myError("paymentstartyear", null, e)}
            />
            <InputPercentage
              label="Defer %"
              name="DeferredRate"
              percent={form.DeferredRate}
              width={90}
              onChange={onChange_t}
              disabled={form.PaymentStartYear === 0 || form.PaymentStartYear <= form.PurchaseYear}
              tooltip="if payments are delayed, this is the growth rate of the initial amount (where the payment is a %)"
              onError={(e) => myError("deferrate", null, e)}
            />
          </Stack>



          <Typography id="s-die-age-slider" variant="h6" gutterBottom>
            Benefit
          </Typography>
          <Stack spacing={4}>
            <Stack direction="row" spacing={2}>

              <InputSelect1ES
                label="Primary Annuitant"
                name="PrimaryAnnuitant"
                value={form.PrimaryAnnuitant}
                onChange={onChange_t}
                onError={(e) => myError("pannuitants", null, e)}
                errors={errors}
                avail={avail.Annuitants}
              />
              <InputSelect1ES
                label="Joint Annuitant"
                name="JointAnnuitant"
                value={form.JointAnnuitant}
                onChange={onChange_t}
                onError={(e) => myError("jannuitants", null, e)}
                errors={errors}
                avail={avail.Annuitants}
              />
            </Stack>


            <Stack direction="row" spacing={2}>


              <InputYear
                label="End Year"
                name="PaymentEndYear"
                year={form.PaymentEndYear}
                birthYear={form.BirthYear}
                onChange={onChange_t}
                // some military pensions are 20 years after start
                minAge={form.PaymentStartYear > 0 ? form.PaymentStartYear - form.BirthYear + 1 : 18}
                maxAge={form.AnnuityType === "Prescribed" ? 91 : 100}
                required={false}
                tooltip="Year in which the we receive the last annuity payment"
                onError={(e) => myError("paymentendyear", null, e)}
              />

              <InputNumber
                label="Guarantee"
                name="GuaranteeYears"
                number={form.GuaranteeYears}
                width={90}
                max={50}
                onChange={onChange_t}
                tooltip="Number of years for which the payment is guaranteed"
                onError={(e) => myError("guaryears", null, e)}
              />

              <InputPercentage
                label="Payment %"
                name="PaymentPercent"
                // disabled={form.Payment.Value > 0}
                percent={form.PaymentPercent}
                onChange={onChange_t}
                errors_={errors}
                width={90}
                tooltip="Percentage of the account that the annuity will return, as a percentage of the contract amount (usually where we don't know that amount, ie. a % of an account in the future)"
                onError={(e) => myError("paymentpercent", null, e)}
              />
              <InputPercentage
                label="Interest %"
                name="InterestRate"
                percent={form.InterestRate}
                width={90}
                onChange={onChange_t}
                disabled={!(form.AnnuityType === "NonPrescribed")}
                tooltip="For NonPrescribed Annuities, this is the effective interest rate for the accrual portion of the payment"
                onError={(e) => myError("interestrate", null, e)}
              />

              <InputPercentage
                label="Survivor %"
                name="PaymentSurvivorPercent"
                percent={form.PaymentSurvivorPercent}
                onChange={onChange_t}
                minPct={50}
                width={90}
                required={(form.JointAnnuitant !== "" && form.PrimaryAnnuitant !== "")}
                tooltip="Percentage of the payment that the survivor will receive "
                onError={(e) => myError("PaymentSurvivorPercent", null, e)}
              />

              <ValueInflatable
                form={form.Payment}
                onChange={onChangeInfValue}
                doInfCap={true}
                doInfMult={true}
                doInfOffset={true}
                avail={avail}
                name="Payment"
                doInf={!(form.AnnuityType === "Prescribed")}
                tooltip="Value of the annuity payment"
                onError={(e) => myError("bridgevalueI", null, e)}
              />
            </Stack>




          </Stack>
          <Input_label
            label="Notes"
            name="Comment"
            value={form.Comment}
            maxLength={800}
            width={800}
            required={false}
            onChange={onChange_t}
            errors={errors}
            onError={(name, e) => myError(name, null, e)}
          />

        </Stack>
      </Box>
    </Container>
  );
};

const AddAnnuityAccount = ({
  show,
  close,
  client_p,
  clientJson,
  c_callback,
  account,
  account_uuid,
  accountType,
  add,
}) => {
  const data = useRef();
  const [form, setForm] = useState();
  const [dataset, setDataset] = useState();
  const [client, setClient] = useState(client_p);
  const [clients, setClients] = useState([client_p]);
  const [errors, setErrors] = useState({})
  const [errmsg, setErrmsg] = useState("")
  const [deleted, setDeleted] = useState(false)

  const getInputData = (client_) => {

    let url = AccountUrl_get(clientJson, "annuity", account, account_uuid, add, accountType);
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          data.current = json;
          setForm(json);
          setClients(json.Clients);
          Update(client_);
          //console.log(data.current);
        }
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const myClose = () => {
    data.current = null;
    setDataset(null);
    close(accountType);
  };

  const putRequest = async () => {
    let url = AccountUrl_put(
      clientJson,
      "annuity",
      form.DataSet[client].Name,
      form.DataSet[client].AccountUuid,
      form.DataSet[client].NameOrig,
      add
    );

    var req = putOptions;
    let post = CleanAvail(form)
    req.body = JSON.stringify(post);
    ftchPlus(url, req)
      .then((response) => {
        console.log("update completed");
        myClose();
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
      });
  };

  const onSubmit = () => {
    console.log(form);
    putRequest();
  };

  useEffect(() => {
    if (show) {
      errorClear(errors)
      setErrmsg("")
      setDeleted(false)
      getInputData(client_p);
    }
  }, [show]);

  const Update = (cl) => {
    setClient(cl);
    setDataset(data.current.DataSet[cl]);
  };


  const onChange_any = (subpath, any) => {
    let path = "DataSet[" + client + "]";
    if (subpath !== "") {
      path += "." + subpath;
    }

    let nf = form;
    nf = set(nf, path, any);
    setForm(nf);
    nf = {
      ...nf,
    };
    setForm(nf);

    Update(client);
    //console.log(nf);
  };
  const onChangeMe = (e, i) => {
    console.log(form)

    if (form.DataSet[client].Annual.length !== 0) {
      let path = "Annual[" + i + "]";
      onChange_any(path, e);
    } else {

      let path = "Annual[" + i + "]";
      onChange_any(path, e);
      let json = form.DataSet[client].Annual.slice();
      json = json.filter((o) => o.Init.length !== 0);
      //console.log(json);
      onChange_any("Annual", json);
    }
  };

  const onClientChange = (cl) => {
    Update(cl);
  };

  const onChange_t = (e) => {
    onChange_any(e.target.name, e.target.value);
  };



  const onDelete = (e, Id) => {
    let json = dataset.Annual.slice();
    json = json.filter((o) => o.Id !== Id);
    onChange_any("Annual", json);
    setDeleted(true)
  }

  const onError = (obj, i, err) => {
    if (i !== null) {
      obj += "[" + i + "]"
    }
    let e = set(errors, obj, err)
    setErrors(e)
  }


  return (
    <>
      <AddDialog
        clientJson={clientJson}
        c_callback={c_callback}
        onClose={myClose}
        open={show}
        clients={clients}
        client={client}
        label={accountType}
        accountType={accountType}
        onClientChange={onClientChange}
        onSubmit={onSubmit}
        errors={errors}
        errmsg={errmsg}
        deleted={deleted}

      >
        {data !== null && dataset !== undefined && dataset !== null && (
          <Stack sx={{ mx: 4 }}>
            {dataset !== undefined && (
              <Stack spacing={2}>
                <InputName
                  value={dataset.Name}
                  accountName={true}
                  onChange={onChange_t}
                  onError={(e) => onError("Name", null, e)}

                />
                <Stack direction="row" spacing={2}>
                  {dataset !== undefined && (
                    <>
                      <Stack spacing={2}>
                        {Arrayify(dataset.Annual).map((d, i) => (
                          <Stack key={i} direction="row" spacing={2}>
                            <Annual
                              avail={dataset.Avail}
                              form={d}
                              onChange={(e) => onChangeMe(e, i)}
                              onError={(e) => onError("value", i, e)}
                            />
                            <Stack sx={{ py: 4 }}>
                              <CollapseDelete
                                onClick={(e) => onDelete(e, d.Id)}
                              />
                            </Stack>
                          </Stack>
                        ))}
                      </Stack>
                    </>
                  )}

                </Stack>
              </Stack>
            )}
          </Stack>
        )}
      </AddDialog>
    </>
  );
};

export default AddAnnuityAccount;
